import request from '@/utils/request'

export function getTaskReportList (data) {
  return request({
    url: 'taskReport/getTaskReportList',
    method: 'post',
    data
  })
}

export function getTotal (data) {
  return request({
    url: 'taskReport/getTotal',
    method: 'post',
    data
  })
}
